// extracted by mini-css-extract-plugin
export default {"section":"NewProduct_section__lsIql","preview":"NewProduct_preview__g2z-E","form":"NewProduct_form__2LBVV"};